import React, { useState } from "react";
import { BurgerIcon } from "../../../components/svgComponents/BurgerFilterIcon";
import { Popover } from "@mui/material";
import { FILTER_TABS_NAME } from "../constants";
import cn from "classnames";
import TransactionTabSvg from "../../../components/svgComponents/TransactionTabSvg";
import ReferralHistorySvg from "../../../components/svgComponents/ReferralHistorySvg";
import ClaimsHistorySvg from "../../../components/svgComponents/ClaimsHistorySvg";

const FilterMenuMobile = ({ isActiveTab, chooseActiveTab }) => {
  const [currentTab, setCurrentTab] = useState(
    FILTER_TABS_NAME.transaction.name
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? "popover-button" : undefined;
  const { transaction, claim, referral } = FILTER_TABS_NAME;

  return (
    <div className="py-4 md:hidden">
      <button
        onClick={(event) => {
          handleClick(event);
        }}
        className="flex items-center gap-1  border w-[160px] px-2 py-2 border-white bg-lightBlue shadow-smallShadow dark:border-darkCardBg dark:bg-darkButBg rounded-lg"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <BurgerIcon />
        </span>
        <p
          className={
            "text-xs md:text-sm font-medium leading-[21px] text-black dark:text-white"
          }
        >
          {currentTab}
        </p>
      </button>
      <Popover
        id={popoverId}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        style={{ marginTop: "8px" }}
        sx={{
          "& .MuiPopover-paper": {
            borderRadius: "8px",
            boxShadow: "0px 4px 13.2px 0px #0000001A",
          },
        }}
      >
        <div className="rounded-lg dark:bg-darkButBg shadow-smallShadow py-2  flex flex-col w-[160px]">
          <button
            className={cn(" flex gap-1 items-center py-1 px-2 rounded-lg", {
              " bg-lightBlue dark:!bg-[#3C3A66] ":
                transaction.value === isActiveTab,
            })}
            onClick={() => {
              setCurrentTab(transaction.name);
              chooseActiveTab(transaction.value);
              handleClose();
            }}
          >
            <TransactionTabSvg isActive={transaction.value === isActiveTab} />
            <p
              className={cn(
                "text-left text-sm font-medium leading-[21px] text-semiBlack dark:text-semiWhite",
                {
                  "!text-black dark:!text-white":
                    transaction.value === isActiveTab,
                }
              )}
            >
              {transaction.name}
            </p>
          </button>
          <button
            className={cn(" flex gap-1 items-center py-1 px-2 rounded-lg", {
              " bg-lightBlue dark:!bg-[#3C3A66] ":
                referral.value === isActiveTab,
            })}
            onClick={() => {
              setCurrentTab(referral.name);
              chooseActiveTab(referral.value);
              handleClose();
            }}
          >
            <ReferralHistorySvg isActive={referral.value === isActiveTab} />
            <p
              className={cn(
                "text-left text-sm font-medium leading-[21px] text-semiBlack dark:text-semiWhite",
                {
                  "!text-black dark:!text-white":
                    referral.value === isActiveTab,
                }
              )}
            >
              {referral.name}
            </p>
          </button>
          <button
            className={cn(" flex gap-1 items-center py-1 px-2 rounded-lg", {
              " bg-lightBlue dark:!bg-[#3C3A66] ": claim.value === isActiveTab,
            })}
            onClick={() => {
              setCurrentTab(claim.name);
              chooseActiveTab(claim.value);
              handleClose();
            }}
          >
            <ClaimsHistorySvg isActive={claim.value === isActiveTab} />
            <p
              className={cn(
                "text-left text-sm font-medium leading-[21px] text-semiBlack dark:text-semiWhite",
                {
                  "!text-black dark:!text-white": claim.value === isActiveTab,
                }
              )}
            >
              {claim.name}
            </p>
          </button>
        </div>
      </Popover>
    </div>
  );
};

export default FilterMenuMobile;
